/**
 * @file automatically generated from MApp.Endpoints.ConnectionContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { ISaveConnection, IGuidObject, IConnection, IConnectionListItem, IValidateConnection, IValidationResult } from '../models';

export class ConnectionContentClient extends MetadataClient {

    public static saveConnection(connection: ISaveConnection) {
        return MetadataClient.ajax<IGuidObject>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/connections`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(connection)
			})
        );
    }

    public static updateConnection(id: string, connection: ISaveConnection) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/connections/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(connection)
			})
        );
    }

    public static getConnection(id: string) {
        return MetadataClient.ajax<IConnection>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/connections/${encodeURIComponent(id)}`)
        );
    }

    public static getConnections() {
        return MetadataClient.ajax<IConnectionListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/connections`)
        );
    }

    public static deleteConnection(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/connections/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidConnection(connection: IValidateConnection) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/connections/isvalid`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(connection)
			})
        );
    }
}
